import { ReactComponent as Arrow } from 'assets/arrowDown.svg'
import { Navigate } from 'hooks/useNavigateWithScrollSave'
import useTranslation from 'hooks/useTranslation'
import useFetchedData from 'hooks/useFetchedData'
import { useParams } from 'react-router-dom'
import Loading from 'components/Loading'
import Error from 'components/Error'
import { SECTION_TYPES } from '..'
import * as urls from 'rest/urls'
import React from 'react'

interface Invoice {
  id: string
  title?: string
  correctedInvoiceId: any
  proformaInvoiceId: any
  fullNumber: string
  description: string
  currency: string
  documentDate: string
  salesDate: string
  paymentDeadline: string
  netAmount: string
  taxAmount: string
  grossAmount: string
  remainingAmount: string
  isPaid: boolean
  contractor_type: string
  issuerCompanyId: string
  issuerName: string
  issuerShortName: string
  customerId: string
  link: string
  contractor: InvoiceContractor
}

interface InvoiceContractor {
  object: string
  id: string
  name1: string
  name2: any
  address1: string
  address2: any
  city: string
  zip: string
  nip: any
  nipEu: any
  pesel: string
  personName: string
  personSurname: any
  customerId: string
  address: string
  companyId: any
  companyName: any
}

interface PaymentsSectionProps {
  navigate: Navigate
}

const PaymentsSection: React.FC<PaymentsSectionProps> = ({ navigate }) => {
  const { id } = useParams<warehouse.PageParams>()
  const { isLoading, data } = useFetchedData<Invoice[]>(`${urls.invoices}?warehousesIds=${id}&limit=3`, 'data')

  const { t } = useTranslation('warehouse')

  return (
    <div>
      <div className='list__header group'>
        <div className='element__title'>{t('invoices')}</div>
        <div
          className='element__subTitle--arrow'
          onClick={() => {
            navigate(`/warehouses/${id}/${SECTION_TYPES.invoices}`)
          }}>
          <span>{t('more')}</span>
          <i className='icon icon--arrow-right' />
        </div>
      </div>
      <div className='list__element --big'>
        {(data && data?.length > 0)
          ? <div className='element__desc'>
            {data.map(({ id, title, fullNumber, documentDate, grossAmount, link }) => <div
              key={id}
              className='group'>
              <div className='element__invoice'>
                <div><b>{t('invoice')} {fullNumber}</b></div>
                {title && <div>{title}</div>}
                <div>{documentDate} - {grossAmount}zł</div>
              </div>
              {link && <Arrow
                onClick={() => {
                  window.open(link, '_blank')
                }} />}
            </div>)}
          </div>
          : isLoading
            ? <Loading />
            : <Error
              staticPos
              text={t('noInvoices')}
            />}
      </div>
    </div>
  )
}

export default PaymentsSection